import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import API from '../api/ApiTool';
import DialogTool from './DialogTool';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const groupByServiceProvider = (numbers) => {
  var group = {}
  numbers.forEach(v => {
    var serviceProvider = v.service_provider
    if (["fs-central", "fs10v5", "fs-atl", "fs-beta"].includes(serviceProvider)) {      
      serviceProvider = "fs" 
    }
    if (!group.hasOwnProperty(serviceProvider)) {
      group[serviceProvider] = 0
    }
    group[serviceProvider] += 1 
  });
  return group
}

const serviceProviderLabel = (serviceProvider) => {
  switch(serviceProvider) {    
    case 'Twilio':
      return "twilio"
    case 'Plivo':
    case 'plivo':
      return "plivo"
    case 'fs':
    case 'FreeSwitch':
      return "fs";
    case 'node-cc':
    case 'Prototype':    
      return "node-cc";
    default:
      return ""
  }
}

const serviceProviderLabelDid = (serviceProvider) => {
  switch(serviceProvider) {    
    case 'Twilio':
      return "twilio"
    case 'Plivo':
    case 'plivo':
      return "plivo"
    case 'fs':
    case 'FreeSwitch':
      return "fs";
    case 'node-cc':
    case 'Prototype':    
      return "node-cc";
    default:
      return ""
  }
}


const BridgeServiceProviderSelector = (props) => {

  console.log('BridgeServiceProviderSelector', props.numbers)
  const refDialogOnlyUpdateBridge = React.createRef();
  const refDialogUpdateGroupBridge = React.createRef();
  
  const bridge = {
    name: props.bridgeTitle,
    id: props.numbers[0].route_to.id,
    service_provider: props.numbers[0].route_to.service_provider,
  }

  var options = ['Twilio', 'Plivo', 'FreeSwitch', 'Prototype'];
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Progress
  const [message, setMessageProgress]  = React.useState("");
  const [title, setTitleProgress] = React.useState("");
  const [dialogProgress, setDialogProgress] = React.useState(false);

  let curIdx = 2;
  switch(bridge.service_provider) {
    case 'twilio':
    case 'Twilio':
      curIdx = 0;
      break;      
    case 'Plivo':
    case 'plivo':
      curIdx = 1;
      break;
    case 'fs':
    case 'FreeSwitch':
      curIdx = 2;
      break;
    case 'node-cc':
    case 'Prototype':    
      curIdx = 3;
      break;    
    default:
      curIdx = 3;
      break;
  }

  //console.log('setSelectedIndex', curIdx, options)
  const [selectedIndex, setSelectedIndex] = React.useState(curIdx);
  const originalIdx = curIdx;


  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  
  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setAnchorEl(null); 

    const serviceProviderGroups = groupByServiceProvider(props.numbers)
    console.log("ServiceProviderGroups:", serviceProviderGroups)
  
    // Found only one service provider on group
    if (Object.keys(serviceProviderGroups).length === 1) {
      refDialogUpdateGroupBridge.current.showDialog()
    }
    

    // Many values
    if (Object.keys(serviceProviderGroups).length > 1) {
      refDialogOnlyUpdateBridge.current.showDialog()
    }

   
  };

  const justUpdateBridge = async () => {
    console.log("justUpdateBridge::Selected: ", options[selectedIndex])
    setTitleProgress("Updating brige")
    setMessageProgress("Updating bridge " + bridge.name + " with service provider:" + options[selectedIndex] )
    setDialogProgress(true)
    let retBridge = await fetchBridge(bridge)
    if(retBridge) {
      setDialogProgress(false)
    } else {
      setMessageProgress("Error on update " + bridge.name )
      setSelectedIndex(originalIdx)
      setTimeout(() => { setDialogProgress(false)}, 1500);
    }
  }

  
  const updateBridgeAndNumbers = async () => {
        
    console.log("updateBridgeAndNumbers::Selected: ", options[selectedIndex])
    let steps = 1 + Object.keys(props.numbers).length;
    setTitleProgress("Step 1 of " + steps)
    setMessageProgress("Updating bridge " + bridge.name + " with service provider:" + options[selectedIndex] )
    setDialogProgress(true)
    let retBridge = await fetchBridge(bridge)
    if (!retBridge) {
      setMessageProgress("Error on update " + bridge.name )
      setSelectedIndex(originalIdx)
      setTimeout(() => { setDialogProgress(false)}, 1500);
      return
    }
    
    
    let current_step = 1;
   
    Object.keys(props.numbers).forEach(function(key) {
      (async () => {
        current_step += 1
        let phone_number = props.numbers[key].number.replace("+", "")
        
        setDialogProgress(true)
        setTitleProgress("Step " + current_step + " of " + steps)
        setMessageProgress("Updating DID " + phone_number + " with service provider " + options[selectedIndex])                  
        let retDid = await fetchNumber(phone_number)      
        if (!retDid) {
          setMessageProgress("Error on update DID " + phone_number )
          setTimeout(() => { setDialogProgress(false)}, 1500);          
          return
        } else {
          props.updateNumbers(phone_number, serviceProviderLabelDid(options[selectedIndex]))
          setDialogProgress(false)
        }
      })()
    })
    
  }

  const fetchBridge = (bridge) => {
    return new Promise(function(resolve) {
      API.POST(`/bridges/telnyx-tools/update_bridge/`, {
        bridge_id: bridge.id, 
        provider: serviceProviderLabel(options[selectedIndex])
      }).then(respBridge => {
        resolve(respBridge.status === 200)
      })
    })
  }

  const fetchNumber = (phone_number) => {
    return new Promise(function(resolve) {
      API.POST(`/bridges/telnyx-tools/update_number/`, {
        phone_number: phone_number, 
        provider: serviceProviderLabelDid(options[selectedIndex])
      }).then(respDid => {
        resolve(respDid.status === 200)        
      })
    })
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialogProgress = () => {
    setDialogProgress(false)
  }

  const closeDialogUpdateGroup = () =>  {
    refDialogUpdateGroupBridge.current.closeDialog()
    setSelectedIndex(originalIdx)
  }


  return (
    
    <div >
      <Dialog
            open={dialogProgress}
            keepMounted
            onClose={handleCloseDialogProgress}
        >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText>
                {message}
            </DialogContentText>
        </DialogContent>        
    </Dialog>
      
      
      <DialogTool         
        id="onlyUpdateBridge" 
        title="Are you sure" 
        message="Are you sure you want to update this bridge service provider ?"
        ref={refDialogOnlyUpdateBridge} 
        onSelectYes={justUpdateBridge}
        />

      <DialogTool         
        id="dialogUpdateGroupBridge" 
        title="Select the option" 
        message="It was detected that all DIDs belong are using the same service provider. 
        Select UPDATE ALL to update all related DIDs, 
        or JUST BRIDGE if you just want to update the bridge service provider. "
        ref={refDialogUpdateGroupBridge} 
        onSelectYes={updateBridgeAndNumbers}
        onSelectNo={justUpdateBridge}
        labelButtonYes="UPDATE ALL"
        labelButtonNo="JUST BRIDGE"
        >
          <Button onClick={closeDialogUpdateGroup} color="primary">CANCEL</Button>
      </DialogTool>
      
      <List component="nav" aria-label="" >     
        <ListSubheader component="div">
        Bridge Service Provider
        </ListSubheader>   
        <ListItem
          button
          aria-haspopup="true"
          aria-controls="lock-menu"          
          primaryText="Bridge Service Provider"
          onClick={handleClickListItem}
        >
          <ListItemText primary={options[selectedIndex]} />
        </ListItem>
      </List>
      <Menu 
        id="lock-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((option, index) => (
          
          <MenuItem 
            key={option}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default BridgeServiceProviderSelector;



// WEBPACK FOOTER //
// ./src/components/BridgeServiceProviderSelector.js